import React from "react";
import "./App.css";
import AppRoutes from "./Routes";

const App: React.FC = () => {
  return (
    <div className="App">
        <AppRoutes />
    </div>
  );
};

export default App;
